<template>
	<Dropdown :position="isSmallScreen ? 'bottom-end' : 'bottom-start'">
		<template #trigger>
			<button type="button" :title="$t('Highlight')" class="w-6 h-6 rounded flex items-center justify-center relative shrink-0" tabindex="-1">
				<!-- Highlighter Icon -->
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="16"
					height="16"
					fill="currentColor"
					viewBox="0 0 256 256"
				>
					<path
						d="M253.66,106.34a8,8,0,0,0-11.32,0L192,156.69,107.31,72l50.35-50.34a8,8,0,1,0-11.32-11.32L96,60.69A16,16,0,0,0,93.18,79.5L72,100.69a16,16,0,0,0,0,22.62L76.69,128,18.34,186.34a8,8,0,0,0,3.13,13.25l72,24A7.88,7.88,0,0,0,96,224a8,8,0,0,0,5.66-2.34L136,187.31l4.69,4.69a16,16,0,0,0,22.62,0l21.19-21.18A16,16,0,0,0,203.31,168l50.35-50.34A8,8,0,0,0,253.66,106.34ZM93.84,206.85l-55-18.35L88,139.31,124.69,176ZM152,180.69,83.31,112,104,91.31,172.69,160Z"
					/>
				</svg>
				<!-- Highlight underline with color indicator -->
				<span
					class="absolute bottom-0 left-1/2 -translate-x-1/2 h-[0.1875rem] rounded"
					:style="{
						width: '1rem',
						backgroundColor: activeHighlight || 'transparent',
						border: activeHighlight ? 'none' : '0.063rem solid rgba(0,0,0,0.3)',
					}"
				/>
			</button>
		</template>
		<template #content>
			<div class="bg-white rounded-lg shadow-lg p-4" style="width: min(10rem, 92vw); max-width: 92vw">
				<div class="grid grid-cols-3 gap-1">
					<button
						v-for="color in highlightColors"
						:key="color"
						type="button"
						class="w-full h-4 rounded border hover:scale-110 transition-all"
						:class="{ 'ring-2 ring-accent': color === activeHighlight }"
						:style="{ backgroundColor: color }"
						@mousedown.prevent="onApplyHighlight(color)"
						@click="onApplyHighlight(color)"
					/>
					<button
						type="button"
						class="col-span-3 mt-1 text-xs text-center bg-gray-200 rounded p-1 w-full"
						@mousedown.prevent="onRemoveHighlight"
						@click="onRemoveHighlight"
					>
						{{ $t("Remove") }}
					</button>
				</div>
			</div>
		</template>
	</Dropdown>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import Dropdown from "@/components/ui/Dropdown.vue";
import type { Editor } from "@tiptap/vue-3";

export default defineComponent({
	name: "HighlightButton",
	components: { Dropdown },
	props: {
		editor: { type: Object as PropType<Editor | null>, required: false },
		isSmallScreen: { type: Boolean, required: true },
		activeHighlight: { type: String as PropType<string | null>, required: false, default: null },
		highlightColors: { type: Array as PropType<string[]>, required: true },
	},
	methods: {
		onApplyHighlight(color: string) {
			(this.editor as any)?.chain?.().focus().setHighlight({ color }).run();
		},
		onRemoveHighlight() {
			(this.editor as any)?.chain?.().focus().unsetHighlight().run();
		},
	},
});
</script>
